import axios from 'axios';

// 保存大类
export function saveTag(data) {
  return axios({
    url: '/classRoom/saveTag',
    method: 'POST',
    data: data,
  });
}

// 大类列表(school:classRoom:tagPage)
export function tagPage(params) {
  return axios({
    url: '/classRoom/tagPage',
    method: 'GET',
    data: params,
  });
}

// 大类列表不分页（school:classRoom:tagList）
export function tagList(params) {
  return axios({
    url: '/classRoom/tagList',
    method: 'GET',
    data: params,
  });
}

// 删除 启用 停用
export function delTag(data) {
  return axios({
    url: '/classRoom/delTag',
    method: 'POST',
    data: data,
  });
}

// 保存小类
export function saveItem(data) {
  return axios({
    url: '/classRoom/saveItem',
    method: 'POST',
    data: data,
  });
}
// 删除 启用 停用 小类
export function delNorm(data) {
  return axios({
    url: '/classRoom/delNorm',
    method: 'POST',
    data: data,
  });
}

// 小类列表(school:classRoom:normPage)
export function normPage(params) {
  return axios({
    url: '/classRoom/normPage',
    method: 'GET',
    data: params,
  });
}

// 小类列表不分页(school:classRoom:normList)
export function normList(params) {
  return axios({
    url: '/classRoom/normList',
    method: 'GET',
    data: params,
  });
}

// 保存班级账号(school:classRoom:saveClassAccount)
export function saveClassAccount(params) {
  return axios({
    url: '/classRoom/saveClassAccount',
    method: 'GET',
    data: params,
  });
}

// 获取所有小类
export function getAllItemList(params) {
  return axios({
    url: '/classRoom/getAllItemList',
    method: 'GET',
    data: params,
  });
}
